import React from 'react';
import { useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';

import { currencyFormat } from 'utilities/common';

export const SectionPrice = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Items.Show']
  );

  const dummy = Array.from({ length: 5 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3">
      <div
        className="fw-semibold py-2 border-bottom mb-3"
        style={{ fontSize: 13 }}
      >
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Stok dan Harga'
        )}
      </div>

      {StateLoading ? (
        dummy?.map((d, i) => (
          <ListHorizontal
            key={i}
            title={<SkeletonText count={1} />}
            content={<SkeletonText count={1} />}
          />
        ))
      ) : (
        <>
          <ListHorizontal
            title="Harga Dasar"
            content={currencyFormat(data?.base_price)}
          />
          <ListHorizontal
            title="Margin (%)"
            content={currencyFormat(data?.margin)}
          />
          <ListHorizontal
            title="Item kena pajak"
            content={
              <span
                className={`badge ${
                  data?.is_vatable ? 'bg-green-lt' : 'bg-red-lt'
                } ms-auto`}
              >
                {data?.is_vatable ? 'Ya' : 'Tidak'}
              </span>
            }
          />

          <ListHorizontal
            title="Item di stok"
            content={
              <span
                className={`badge ${
                  data?.is_stockable ? 'bg-green-lt' : 'bg-red-lt'
                } ms-auto`}
              >
                {data?.is_stockable ? 'Ya' : 'Tidak'}
              </span>
            }
          />
          {data?.is_stockable && (
            <ListHorizontal title="Safety Stock" content={data?.safety_stock} />
          )}

          <ListHorizontal
            title="Stok Tersedia"
            content={currencyFormat(data?.stock_available)}
          />
        </>
      )}
    </section>
  );
};
